
<template>
  <client-only>
    <div class="inner-wrap">
      <History
        class="mt-2"
        :all-cv="AllCv"
        :sent-cv-history-count="SentCvHistoryCount"
      />
    </div>
  </client-only>
</template>

<script>
import History from '@/components/Candidates/Pages/History/History';
import SeoOptimization from '@/components/mixins/SeoOptimization';
import { CV_HISTORY } from '@/lib/api.js';

export default {
  name: 'historyPage',
  layout: 'personal',
  middleware: 'personalPage',
  mixins: [SeoOptimization],

  components: {
    History,
  },
  head() {
    return {
      link: [{ rel: 'canonical', href: this.seodata.canonicalUrl }],
      title: this.seodata.pageTitle,
      meta: this.seodata.metaData,
    };
  },
  async asyncData(context) {
    try {
      const { data } = await context.$axios(`${CV_HISTORY}`);

      if (data.IsError) {
        throw 'שגיאת מערכת ';
      }
      return {
        AllCv: data.ResultList,
        SentCvHistoryCount: parseInt(data.Count),
        seodata: {
          metaData: data.SEO.MetaDataItems,
          pageTitle: data.SEO.title,
          canonicalUrl: data.SEO.CanonicalUrl,
        },
      };
    } catch (err) {
      context.error({
        statusCode: 404,
        path: context.route.fullPath,
        message: 'Post not found ' + err,
      });
      console.log(err);
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
